"use client";

import { useCallback, useEffect, useState } from "react";

const TOKEN_KEY = "psx_auth_token";
const AUTH_EVENT = "psx-auth-changed";

type InternalVolumeAccess = {
  allowed: boolean;
  checked: boolean;
  token: string | null;
};

function readToken(): string | null {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(TOKEN_KEY);
}

export function useInternalVolumeAccess(): InternalVolumeAccess {
  const [state, setState] = useState<InternalVolumeAccess>({
    allowed: false,
    checked: false,
    token: null,
  });

  const checkAccess = useCallback(async () => {
    const token = readToken();
    if (!token) {
      setState({ allowed: false, checked: true, token: null });
      return;
    }

    try {
      const response = await fetch("/api/internal/volume-access", {
        headers: { Authorization: `Bearer ${token}` },
        cache: "no-store",
      });
      setState({ allowed: response.ok, checked: true, token });
    } catch {
      setState({ allowed: false, checked: true, token });
    }
  }, []);

  useEffect(() => {
    void Promise.resolve().then(checkAccess);
    window.addEventListener("storage", checkAccess);
    window.addEventListener(AUTH_EVENT, checkAccess);
    return () => {
      window.removeEventListener("storage", checkAccess);
      window.removeEventListener(AUTH_EVENT, checkAccess);
    };
  }, [checkAccess]);

  return state;
}

export function InternalVolumeUnavailable() {
  return (
    <section className="strategy-detail-section">
      <div className="strategy-detail-container">
        <h1 className="page-title">Page not found</h1>
        <p className="page-subtitle">The requested page is unavailable.</p>
      </div>
    </section>
  );
}
